/**
 * keep-alive 多地图页切换：
 * - 切走：destroy 释放 WebGL（避免多实例白屏）
 * - 切回：按容器重建/resize（瓦片走浏览器缓存，不必重载 JS SDK）
 */

const DEFAULT_RESIZE_DELAYS = [0, 80, 200, 400]

function safeMapResize(map) {
  if (!map || typeof map.resize !== 'function') return
  try {
    map.resize()
  } catch (e) {
    /* ignore */
  }
}

function isElementMeasurable(el) {
  if (!el || typeof el.getBoundingClientRect !== 'function') return false
  const rect = el.getBoundingClientRect()
  return rect.width > 1 && rect.height > 1
}

/**
 * 切回标签后刷新显示（始终尝试 resize；容器未就绪则短轮询）
 */
export function refreshAmapMapDisplay(map, afterResize, options) {
  if (!map) return
  const delays = (options && options.delays) || DEFAULT_RESIZE_DELAYS
  const container = options && options.container

  const runAfter = () => {
    if (typeof afterResize === 'function') {
      try {
        afterResize()
      } catch (e) {
        /* ignore */
      }
    }
  }

  const tick = () => {
    safeMapResize(map)
  }

  const finish = () => {
    tick()
    runAfter()
  }

  tick()
  if (typeof requestAnimationFrame === 'function') {
    requestAnimationFrame(() => {
      tick()
      requestAnimationFrame(finish)
    })
  } else {
    finish()
  }
  delays.forEach((ms) => setTimeout(tick, ms))
  setTimeout(finish, Math.max(...delays, 0) + 80)

  if (!container) return
  let attempts = 0
  const retry = () => {
    if (isElementMeasurable(container) || attempts >= 24) {
      finish()
      return
    }
    attempts += 1
    setTimeout(retry, 50)
  }
  if (!isElementMeasurable(container)) {
    setTimeout(retry, 50)
  }
}

/** 释放 Map 实例（切走标签时） */
export function destroyAmapMapInstance(map) {
  if (!map) return
  try {
    if (typeof map.destroy === 'function') {
      map.destroy()
    }
  } catch (e) {
    /* ignore */
  }
}

export function refreshPathSimplifierDisplay(pathSimplifierIns) {
  if (!pathSimplifierIns) return
  try {
    if (typeof pathSimplifierIns.render === 'function') {
      pathSimplifierIns.render()
    } else if (typeof pathSimplifierIns.renderLater === 'function') {
      pathSimplifierIns.renderLater()
    }
  } catch (e) {
    /* ignore */
  }
}

export function refreshTrajectoryPlugInMap(vm) {
  if (!vm) return
  const container = vm.$refs && vm.$refs.mapBox ? vm.$refs.mapBox : null
  refreshAmapMapDisplay(vm.mapInstance, () => {
    refreshPathSimplifierDisplay(vm.pathSimplifierIns)
  }, { container })
}

export function refreshTrackTrajectoryRef(parent) {
  if (!parent || !parent.$refs) return
  const track = parent.$refs.trackTrajectory
  if (!track) return
  refreshTrajectoryPlugInMap(track)
}
